import {
  UserIcon,
  BuildingOfficeIcon,
  BriefcaseIcon,
} from "@heroicons/react/20/solid";

const timeline = [
  {
    id: 1,
    target: "Ерөнхий Захирал",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 2,
    target: "Захирлын зөвлөх",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 3,
    target:
      "Захиргаа хамтын ажиллагааны алба",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 4,
    target:
      "Санхүү бүртгэлийн алба",
    icon: UserIcon,
    iconBackground: "bg-[#08B3EC]",
  },
  {
    id: 5,
    target: "Хүүхэд хөгжлийн хэлтэс ",
    icon: BuildingOfficeIcon,
    iconBackground: "bg-[#08B3EC]",
    item: "Хөтөлбөр хэрэгжилтийн алба / Хоол үйлдвэрлэлийн алба / Эрүүл мэнд, үйлчилгээний алба",
  },
  {
    id: 6,
    target: "Нийтлэг үйлчилгээний хэлтэс",
    icon: BuildingOfficeIcon,
    iconBackground: "bg-[#08B3EC]",
    item: "Дулаан үйлдвэрлэлийн алба / Барилга ашиглалт, автын алба / Харуул хамгаалалтын алба",
  }
];

const hr = [
  {
    id: 1,
    target: "Ажлын байр",
    icon: BriefcaseIcon,
    iconBackground: "bg-[#08B3EC]",
    item: "﻿﻿Бүлгийн багш-хөтөлбөрийн удирдагч / Тайзны техникч / Тогооч   / Зөөгч / Ачигч  / Үйлчлэгч / Угаагч",
  },
  {
    id: 2,
    target: "Нийтлэг шаардлага",
    icon: BriefcaseIcon,
    iconBackground: "bg-[#08B3EC]",
    item: " ﻿﻿Мэргэжлийн дагуу сургууль төгссөн. (гэрээт бүлгийн удирдагч-оюутан байж болно) / Нас, хүйс харгалзахгүй (бүлгийн удирдагч-21-26 насны) / Хүүхэдтэй ажиллах хүсэл сонирхолтой / Харилцааны эерэг хандлагатай",
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function HumanResources() {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-gradient-to-br from-primary-50 via-fun-50 to-happy-50">
      <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <div className="inline-block relative">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-dark-900 mb-4 relative z-10">
              <span className="relative z-10">👥 Хүний нөөц</span>
              <div className="absolute -top-2 -right-2 w-10 h-10 bg-playful-400 rounded-full animate-bounce-slow"></div>
            </h1>
          </div>
        </div>
        
        <section className="grid lg:grid-cols-2 gap-8 mb-8">
          {/* Structure */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-large border-4 border-primary-200 animate-slide-up">
            <div className="flex items-center gap-3 mb-8">
              <span className="text-4xl">🏢</span>
              <h2 className="text-2xl sm:text-3xl font-bold text-dark-900">
                Хүний нөөцийн бүтэц
              </h2>
            </div>
            <ul className="space-y-6">
              {timeline.map((event, eventIdx) => (
                <li key={event.id} className="relative">
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-primary-500 to-fun-500 flex items-center justify-center shadow-medium">
                        <event.icon className="h-6 w-6 text-white" aria-hidden="true" />
                      </div>
                      {eventIdx < timeline.length - 1 && (
                        <div className="absolute left-6 top-14 w-0.5 h-full bg-gradient-to-b from-primary-300 to-fun-300"></div>
                      )}
                    </div>
                    <div className="flex-1">
                      <p className="font-bold text-lg text-dark-900 mb-3">
                        {event.target}
                      </p>
                      {event.item && (
                        <ul className="space-y-2 ml-4">
                          {event.item.split("/").filter(opt => opt.trim()).map((opt, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-dark-600">
                              <span className="text-primary-500 mt-1">•</span>
                              <span>{opt.trim()}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Open Positions */}
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-large border-4 border-playful-200 animate-slide-up" style={{ animationDelay: '0.1s' }}>
            <div className="flex items-center gap-3 mb-8">
              <span className="text-4xl">💼</span>
              <h2 className="text-2xl sm:text-3xl font-bold text-dark-900">
                Нээлттэй ажлын байр
              </h2>
            </div>
            <ul className="space-y-6 mb-8">
              {hr.map((event, eventIdx) => (
                <li key={event.id} className="relative">
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-playful-500 to-joy-500 flex items-center justify-center shadow-medium">
                        <event.icon className="h-6 w-6 text-white" aria-hidden="true" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <p className="font-bold text-lg text-dark-900 mb-3">
                        {event.target}
                      </p>
                      {event.item && (
                        <ul className="space-y-2 ml-4">
                          {event.item.split("/").filter(opt => opt.trim()).map((opt, idx) => (
                            <li key={idx} className="flex items-start gap-2 text-dark-600">
                              <span className="text-playful-500 mt-1">•</span>
                              <span>{opt.trim()}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            
            <div className="bg-gradient-to-r from-primary-50 to-fun-50 rounded-2xl p-6 border-2 border-primary-200">
              <p className="text-dark-700 mb-4">
                Дэлгэрэнгүйг{" "}
                <a
                  href="https://www.zangia.mn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-bold text-primary-600 underline hover:text-primary-700"
                >
                  zangia.mn
                </a>{" "}
                сайтын ажлын байрны зар болон доорх хаягаас:
              </p>
              <div className="flex flex-col sm:flex-row gap-4 text-dark-700">
                <div className="flex items-center gap-2">
                  <span className="text-xl">📞</span>
                  <span className="font-semibold">Утас: 75056010-4, 91104545</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xl">📧</span>
                  <span className="font-semibold">Майл: hr@nairamdal.mn</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
